import assetPath from '/app/packages/entity-pages/entity-pages-employees/src/assets/icon-fencing.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')